import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { Column } from 'react-table';
import { Portrait } from '@galaxy/lorule-react-commons';
import DataGrid from '../../common/datatables/DataGrid';
import AmCommentModal from '../modal/AmCommentModal';
import { ActionMemo } from '../../../api/actionMemoApiTypes';
import { AmStatusType, DATE_TIME_FORMAT } from '../../../utils/Constants';
import { formatDate } from '../../../utils/displayUtils';

const Comments = (props: { detail: ActionMemo; refresh: () => void }) => {
    const { detail } = props;

    const columns = React.useMemo(
        () => [
            {
                Header: '',
                accessor: 'commentedByEmailAddress',
                Cell: (cellProps: { value: string }) =>
                    useMemo(
                        () => (
                            <div className="profile-photo">
                                <Portrait username={cellProps.value} roundedCircle />
                            </div>
                        ),
                        [],
                    ),
                disableSortBy: true,
                xs: 3,
                sm: 3,
                xl: 1,
            },
            {
                Header: 'Name/Title',
                accessor: 'commentedByName',
                Cell: (cellProps: {
                    value: string;
                    row: {
                        original: {
                            commentedByTitle: string;
                        };
                    };
                }) =>
                    useMemo(
                        () => (
                            <>
                                <div>{cellProps.value}</div>
                                <div className="font-italic font-weight-light">
                                    <small>{cellProps.row.original.commentedByTitle}</small>
                                </div>
                            </>
                        ),
                        [],
                    ),
                xs: 9,
                sm: 9,
                xl: 2,
            },
            {
                Header: 'On',
                accessor: 'commentedOn',
                Cell: (cellProps: { value: string }) =>
                    useMemo(() => <span>{formatDate(cellProps.value, DATE_TIME_FORMAT)}</span>, []),
                xs: 6,
                sm: 6,
                xl: 3,
            },
            {
                Header: 'Comment',
                accessor: 'commentMessage',
                disableSortBy: true,
                xs: 12,
                sm: 12,
                xl: 6,
            },
        ],
        [],
    );

    return (
        <>
            {detail.id &&
                (detail.amStatus === AmStatusType.Draft ||
                    detail.amStatus === AmStatusType.Pending ||
                    detail.amStatus === AmStatusType.Hold ||
                    detail.amStatus === AmStatusType.Approved) && (
                    <div className="col-sm-12 my-2 py-2 text-right border-bottom">
                        <AmCommentModal
                            title="Add Comment"
                            toggleButton={
                                <Button variant="outline-primary" className="ml-auto" size="sm">
                                    <i className="far fa-edit" /> Add
                                </Button>
                            }
                            amId={detail.id}
                            amNumber={detail.amNumber}
                            supNumber={detail.supNumber}
                            onSubmit={props.refresh}
                        />
                    </div>
                )}
            <div className="react-table px-2">
                <DataGrid
                    columns={columns as Column<Object>[]}
                    data={detail.comments}
                    noGlobalFilter
                    noPagination
                    initialState={{ pageSize: 1000 }}
                    mobileShowList
                />
            </div>
        </>
    );
};

export default Comments;
